import React, {Fragment} from 'react'

export const About = () => {
    return (
        <Fragment>
            <h1>About this app</h1>
            <p>App to search Github users</p>
            <p>Version: 0.1.0</p>
        </Fragment>
    )
}
